import { ApolloLink } from './ApolloLink';

export const concat = ApolloLink.concat;
